import React from "react";
import adsbVerifiedBadge from "../../assets/images/adsb-verififed-badge.svg";
import bmsVerifiedBadge from "../../assets/images/bms-verified-badge.svg";
import "../css/VerificationIcon.css";

const VerificationIcon = ({
  adsbVerified,
  bmsVerified,
  className = "",
  alt,
}) => {
  if (!adsbVerified && !bmsVerified) {
    return null;
  }

  return (
    <div className={`verification-icon-wrapper ${className}`.trim()}>
      {bmsVerified && (
        <img
          className="verification-icon"
          src={bmsVerifiedBadge}
          alt={alt ? `${alt}-bms` : "bms-verified-badge"}
        />
      )}
      {adsbVerified && (
        <img
          className="verification-icon"
          src={adsbVerifiedBadge}
          alt={alt ? `${alt}-adsb` : "adsb-verified-badge"}
        />
      )}
    </div>
  );
};

export default VerificationIcon;

